
import * as moment from "moment";
import { FileDataShare } from "../interfaces/share-files.interfaces";

export class ShareFilesManager {
    data?: FileDataShare;

    constructor(data?: FileDataShare) {
        this.data = data;
    }

    getCoordinates(){
        switch(this.data?.fileType){
            case FileType.listMovements:
                return ["A4","B4","C4","D4","E4","F4","G4","H4","I4","J4","K4","L4"];
            case FileType.reportByDates:
                return ["A4","B4","C4","D4"];
            case FileType.reportByCategories:
                return ["A4","B4","C4"];
            case FileType.trendsCategories :
                return ["A4","B4","C4"];
            case FileType.schedule:
                return ["A4","B4","C4","D4"]
        }
    }

    getHeaders(){
        switch(this.data?.fileType){
            case FileType.listMovements:
                return ["", "fecha", "hora", "cuenta", "categoría", "subcategoría", "ingreso", "gasto",
                        "descripcion", "beneficiario", "estado", "lugar"];
            case FileType.reportByDates:
                return ["", "Periodo","Ingreso", "Gasto"];
            case FileType.reportByCategories:
                return ["", "Categoria", "Saldo"];
            case FileType.trendsCategories:
                return ["periodo", "categoria", "balance"];
            case FileType.schedule:
                return ["Dia", "Ingreso", "Gasto", "Saldo"];
        }
    }

    getData(): any{
        switch (this.data?.fileType) {
            case FileType.listMovements:
                return this.getDataByListMovements();
            case FileType.reportByDates:
                return this.getDataByReportDate();
            case FileType.reportByCategories:
                return this.getDataByReportCategory();
            case FileType.trendsCategories:
                return this.getDataByTrendsReportCategory();
            case FileType.schedule:
                return this.getDataSchedule();
        }
    }

    getDataByListMovements(){
        let array : string[][] = [];
        let data = this.data?.movements;
        data?.forEach( movement => {
            let income = 0, expense = 0;
            if (movement.sign == "+") {
                income = movement.amount!;
            } else {
                expense = movement.amount!;
            }
            let category = movement.category?.name ?? "";
            let subCategory = movement.subcategory?.name?? "";
            let beneficiary = movement.beneficiary?? "";
            let placeName = movement.placeName?? "";
            let detail = movement.detail?? "";

            let date = moment(movement.date).format('YYYY-MM-DD');
            let time = moment(movement.date).format('hh:mm');
            let arrayMovements : string[] = [movement.pkMovement!.toString(), date, time, movement.account!.accountName, category,
            subCategory, income.toString(), expense.toString(), detail, beneficiary, this.getStatus(movement.status!), placeName];
            array.push(arrayMovements);
        });
        return array;
    }

    getDataByReportDate(){
        let array : string[][] = [];
        let data = this.data?.reportDate;
        let id = 1;
        data?.forEach(report => {
            let income = report.totalPlus;
            let expense = report.totalMinus;
            let period = report.title;
            let arrayReport : string[] = [id.toString(), period, income.toString(), expense.toString()];
            array.push(arrayReport);
            id++;
        });
        return array;
    }

    getDataByReportCategory(){
        let array : string[][] = [];
        let data = this.data?.reportCategory;
        let id = 1;
        data?.forEach(report => {
            let category = report.category;
            let balance = report.total;
            let arrayReport : string[] = [id.toString(), category, balance.toPrecision()];
            array.push(arrayReport);
            id++;
        });
        return array;
    }

    getDataByTrendsReportCategory(){
        let array : string[][] = [];
        let data = this.data?.reportTrend;
        data?.forEach(report => {
            let balance  = 0;
            let dateArray = [report.title,"",""];
            let pushDateArray : boolean = false;
            report.trendsData.forEach(category => {
                let total = 0;
                if (category.total != null) {
                    if (!pushDateArray) {
                        array.push(dateArray);
                        pushDateArray = true;
                    }
                    if (category.sign == "-") {
                        balance += category.total;
                        total = category.total;
                    } else {
                        balance -= category.total;
                        total -=category.total;
                    }
                }
                let categoryArray: any[] = [null, category.category, total.toString()];
                array.push(categoryArray);
            });
            if (balance != 0) {
                let balanceArray: any[] = [null, null, balance.toString()];
                array.push(balanceArray);
            }
        });

        return array;
    }

    getDataSchedule(){
        let array : string[][] = [];
        let data = this.data?.schedule;
        data?.forEach(controlled => {
            if (controlled.date != null) {
                let day = moment(controlled.date).format('DD');
                let income = +controlled.plusTotal ?? 0;
                let expense = +controlled.minusTotal ?? 0;
                let total = income - expense;
                let scheduleControlled: string[] = [day, income.toString(), expense.toString(), total.toString()];
                array.push(scheduleControlled);
            }
        });
        return array;
    }

    balanceData(){
        switch (this.data?.fileType) {
            case FileType.listMovements:
            return [null, null, null, null, null, null, "Saldo", this.getBalance()];
            case FileType.reportByDates:
                return [null, null, "Saldo", this.getBalance()];
            case FileType.reportByCategories:
                return [null, "Saldo", this.getBalance()];
            case FileType.trendsCategories:
                return [null, null, this.getBalance()];
            case FileType.schedule:
                return [null, this.getBalanceIncome(), this.getBalanceExpense()];
        }
    }

    getBalance(){
        switch (this.data?.fileType) {
            case FileType.listMovements:
                return this.getBalanceMovements();
            case FileType.reportByDates:
                return this.getBalanceReportDate();
            case FileType.reportByCategories:
                return this.getBalanceReportCategory();
            case FileType.trendsCategories:
                return this.getBalanceTrendCategory();
        }
    }

    getBalanceMovements(){
        let balance = 0;
        this.data?.movements!.forEach(movement => {
          if (movement.sign == "+") {
            balance += movement.amount!;
          } else {
            balance -= movement.amount!;
          }
        });
        return balance.toString();
    }

    getBalanceReportDate(){
        let balance = 0;
        this.data?.reportDate?.forEach(report => {
            let income = report.totalPlus;
            let expense = report.totalMinus;
            balance += income;
            balance -= expense;
        });
        return balance.toString();
    }

    getBalanceReportCategory(){
        let balance = 0;
        this.data?.reportCategory!.forEach(report => {
            balance += report.total;
        });
        return balance.toString();
    }

    getBalanceTrendCategory(){
        let balance  = 0;
        let data = this.data?.reportTrend;
        data?.forEach(report => {
            report.trendsData.forEach(category => {
                if (category.total != null) {
                    if (category.sign == "+") {
                        balance += category.total;
                    } else {
                        balance -= category.total;
                    }
                }
            });
        });
        return balance.toString();
    }

    getBalanceIncome(){
        let balance = 0;
        let data = this.data?.schedule;
        data?.forEach(controlled => {
            let income = +controlled.plusTotal?? 0;
            balance += income;
        });
        return balance.toString();
    }

    getBalanceExpense(){
        let balance = 0;
        let data = this.data?.schedule;
        data?.forEach(controlled => {
            let expense = +controlled.minusTotal?? 0;
            balance += expense;
        });
        return balance.toString();
    }

    getStatus(status: number){
      return (status == 0) ? "Pendiente" : "Confirmado";
    }

    getMerge(){
        switch (this.data?.fileType) {
            case FileType.listMovements:
                return [{ s: { r: 0, c: 11}, e: { r: 0, c: 0 } },
                        { s: { r: 1, c: 11}, e: { r: 1, c: 0 } },
                        { s: { r: 2, c: 11}, e: { r: 2, c: 0 } },
                        ];
            case FileType.reportByDates || FileType.schedule:
                return [{ s: { r: 0, c: 3}, e: { r: 0, c: 0 } },
                        { s: { r: 1, c: 3}, e: { r: 1, c: 0 } },
                        { s: { r: 2, c: 3}, e: { r: 2, c: 0 } },
                        ];
            case FileType.reportByCategories | FileType.trendsCategories:
                return [{ s: { r: 0, c: 2}, e: { r: 0, c: 0 } },
                    { s: { r: 1, c: 2}, e: { r: 1, c: 0 } },
                    { s: { r: 2, c: 2}, e: { r: 2, c: 0 } },
                    ];
        }
    }
}

enum FileType{
    listMovements,
    reportByDates,
    reportByCategories,
    trendsCategories,
    schedule,
}
